export default {
  ja:[
    "出金先口座情報",
    "戻る",
    "作成",
  ],
  en: [
    "Your bank account",
    "back",
    "create",
  ]
}
